export const enum PrepMode {
  auto = 'auto',
  manual = 'manual',
}

export const OFO_NAMES = { meituan: '美团', eleme: '饿了么' };

export type Ofo = keyof typeof OFO_NAMES;
